import { mapGetters } from 'vuex';
import { errorMessage } from '@/utils/message.js';
import accountInfoService from '../../account-info.service.js';
import UploadImage from '@/components/upload-image/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import regExp from '@/utils/regExp.js';

export default {
  components: {
    ProcessNavigation,
    UploadImage
  },
  data() {
    return {
      processList: ['变更后法人信息', '业务审批员审批', '变更后法人验证'],
      legalIdTypeList: [],
      step: 1,
      form: {
        legalName: '',
        legalIdCard: '',
        legalIdType: '',
        legalMobile: '',
        files: [
          {imgEnumType: 'ID_CARD_FRONT_APPROVE', title: '法人代表人身份证个人面', filePaths: [], defaultImage: [], inputValue: null},
          {imgEnumType: 'ID_CARD_BACK_APPROVE', title: '法人代表人身份证国徽面', filePaths: [], defaultImage: [], inputValue: null},
          {imgEnumType: 'LICENSE_IMG_APPROVE', title: '农村集体经济组织登记证', filePaths: [], defaultImage: [], inputValue: null}
        ]
      },
      rules: {
        legalName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        legalIdType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        legalIdCard: [
          { required: true, message: '请输入证件号', trigger: 'blur' },
          { pattern: regExp.idCard, message: '请输入正确的证件号', trigger: 'blur'}
        ],
        legalMobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: regExp.phone, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'captchaImageSrc',
      'ticket',
      'userType'
    ])
  },
  created() {
    this.getIdTypeList();
  },
  methods: {
    fileRules (item) {
      let required = true;
      return {
        required: required,
        message: '请上传' + item.title,
        trigger: 'change'
      };
    },
    uploadImage (index, event) {
      this.form.files[index].filePaths = event;
      if (event.length) {
        this.form.files[index].inputValue = event.length;
      } else {
        this.form.files[index].inputValue = null;
      }
    },

    // 获取字典：证件类型列表
    getIdTypeList() {
      this.$store.dispatch('getSelectDictList', 'ID_TYPE').then(res => {
        if (res.code === '0') {
          this.legalIdTypeList = res.data;
        }
      });
    },

    validateForm() {
      let validStatus = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          validStatus = valid;
        }
      });
      return validStatus;
    },
    submit() {
      if (!this.validateForm()) { return; };
      let paramsFiles = [];
      this.form.files.forEach(item => {
        let tempItem = {
          fileName: item.title,
          imgEnumType: item.imgEnumType,
          urls: [item.filePaths[0].sourceImgUrl]
        };
        paramsFiles.push(tempItem);
      });
      // changeType=1 信息员变更，2法人变更
      let params = {
        companyForm: {
          ...this.form
        },
        type: this.userInfo.type,
        files: paramsFiles,
        changeType: 2
      };
      accountInfoService.updateUserInfo(params).then(res => {
        if (res && res.code === '0') {
          // 信息修改成功后 清除信息并跳转到登陆页面
          // successMessage('法人成功');
          this.$router.push('/person-center/account-info/modify-legal-second');
        } else {
          errorMessage(res.reason);
        }
      }, error => {
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    }
  }
};
